import { selectSpaceOrCommunityId } from '@lumapps/communities/ducks/selectors';
import { Dispatch, GetFrontOfficeState } from '@lumapps/redux/types';
import { logException } from '@lumapps/utils/log/logException';

import { FetchBlockParams, getWidgetBlocksFromLegacy } from '../../api';
import { LegacyWidget } from '../../types';
import { getWidget } from '../selectors';
import { fetchWidgetBlocks } from './fetchWidgetBlocks';

export const fetchWidgetBlocksByProperties =
    ({ params, legacyWidget }: { params?: FetchBlockParams; legacyWidget: LegacyWidget }) =>
    (dispatch: Dispatch, getState: GetFrontOfficeState) => {
        const currentState = getState();
        const { filters: activeFilters } = getWidget(currentState, { widgetId: legacyWidget.uuid }) || {};
        const communityId = selectSpaceOrCommunityId(currentState);
        const communityParams =
            communityId && (legacyWidget.widgetType === 'event-list' || legacyWidget.widgetType === 'article-list')
                ? { communityId }
                : undefined;
        const fetchParams = { filters: activeFilters, ...params, ...communityParams };

        dispatch(
            fetchWidgetBlocks(
                legacyWidget.uuid,
                (acceptLanguageHeader) => getWidgetBlocksFromLegacy(legacyWidget, fetchParams, acceptLanguageHeader),
                fetchParams,
            ),
        ).catch(logException);
    };
